import Vue from 'vue'
import Router from 'vue-router'
import Header from '@/components/Header'
import Slide from '@/components/Slide'
import Intro from '@/components/Intro'
import MapRoad from '@/components/Map'
import Blog from '@/components/Blog'
import BlogPage from '@/components/BlogPage'
import BlogPageDetail from '@/components/BlogPageDetail'
import About from '@/components/About'
import Comment from '@/components/Comment'
import Subscribe from '@/components/Subscribe'
import Footer from '@/components/Footer'
import privacyPolicy from '@/components/PrivacyPolicy'
import Manager from "@/components/Manager"
import GalleryPage from "@/components/Gallery"
import GalleryPageDetail from "@/components/GalleryDetail"
import Sidemenu from "@/components/admin-manage/Sidemenu"
import Activity from "@/components/admin-manage/Activity"
import ActivityEdit from "@/components/admin-manage/ActivityEdit"
import Article from "@/components/admin-manage/Article"
import ArticleEdit from "@/components/admin-manage/ArticleEdit"

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [{
            path: '/',
            name: 'home',
            components: {
                default: Header,
                Slide: Slide,
                Intro: Intro,
                Map: MapRoad,
                Blog: Blog,
                About: About,
                Comment: Comment,
                Subscribe: Subscribe,
                Footer: Footer
            }
        },
        {
            path: '/blog',
            name: 'blog',
            components: {
                default: Header,
                BlogPage: BlogPage,
                Footer: Footer
            }
        },
        {
            path: '/blog/:vendor/:activity',
            name: 'blog-detail',
            components: {
                default: Header,
                BlogPageDetail: BlogPageDetail,
                Footer: Footer
            }
        },
        {
            path: '/gallery/:type/:galleryInfo',
            name: 'gallery-detail',
            components: {
                default: Header,
                GalleryDetail: GalleryPageDetail,
                Footer: Footer
            }
        },
        {
            path: '/gallery',
            name: 'gallery',
            components: {
                default: Header,
                Gallery: GalleryPage,
                Footer: Footer
            }
        },
        {
            path: '/menu',
            name: 'menu',
            components: {
                default: Header,
                Footer: Footer
            }
        },
        {
            path: '/about',
            name: 'about',
            components: {
                default: Header,
                About: About,
                Footer: Footer
            }
        },
        {
            path: '/privacyPolicy',
            name: 'privacyPolicy',
            components: {
                default: Header,
                GalleryDetail: privacyPolicy,
                Footer: Footer
            }
        },
        {
            path: '/manager',
            name: 'manager',
            components: {
                default: Header,
                Manager: Manager
            }
        },
        {
            path: '/admin-manage',
            name: 'activity',
            components: {
                default: Sidemenu,
                Activity: Activity
            }
        },
        {
            path: '/admin-manage/activityEdit/:index',
            name: 'activityEdit',
            components: {
                default: Sidemenu,
                ActivityEdit: ActivityEdit,
            }
        },
        {
            path: '/admin-manage/article',
            name: 'article',
            components: {
                default: Sidemenu,
                Article: Article,
            }
        },
        {
            path: '/admin-manage/article/articleEdit/:index',
            name: 'articleEdit',
            components: {
                default: Sidemenu,
                ArticleEdit: ArticleEdit,
            }
        },
    ]
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js